import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CookiepolicyComponent } from './cookiepolicy/cookiepolicy.component';

import { ChangePasswordComponent } from './authentication/change-password/change-password.component';
import { ErrorComponent } from './error/error.component';
import { ListingComponent } from './dashboard/listing/listing.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginComponent } from './authentication/login/login.component';
import { routes } from './app.routes';


// const routes: Routes = [
//   // { path: "", redirectTo: "login", pathMatch: "full" },
//   // { path: "login", component: LoginComponent },
//   // { path: "signin", component: LoginComponent },
//   { path: "client", loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
//   { path: "home", loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
//   { path: "change-password", component: ChangePasswordComponent },
//   { path: "cookie-policy", component: CookiepolicyComponent },
//   { path: "error", component: ErrorComponent },
//   { path: "logout", component: LogoutComponent },
//   { path: '', redirectTo: 'client/login', pathMatch: 'full' },
//   { path: '**', redirectTo: 'client/login', pathMatch: 'full' }
// ];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
